/* hg-qty.js — sélecteur de quantité sur les fiches produit hors gazon.
   Le gabarit sections/hg-product.liquid pose une quantité figée
   (<input type="hidden" name="quantity" value="1">) dans sa branche générique
   .hg-prod-buy — celle qui sert les dalles caoutchouc et les accessoires.
   Ce script la remplace par un sélecteur +/- avec total en direct, et affiche
   le prix barré quand le produit a un compare_at_price.
   N'agit que sur .hg-prod-buy : le configurateur gazon (.hg-calc) et les
   rouleaux (.hg-rouleau) ne sont pas touchés.
   Sans JavaScript, la page garde le comportement actuel (quantité 1). */
(function () {
  'use strict';

  var CSS = [
    '.hg-prod-qty{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:14px;flex-wrap:wrap}',
    '.hg-prod-qty__label{font-size:14px;font-weight:700;color:var(--hg-navy)}',
    '.hg-prod-qty__ctrl{display:flex;align-items:center;border:2px solid var(--hg-green-pale);border-radius:10px;overflow:hidden}',
    '.hg-prod-qty__btn{width:42px;height:46px;border:none;background:#f4f8ef;color:var(--hg-navy);font-size:20px;font-weight:800;cursor:pointer;line-height:1;touch-action:manipulation;font-family:inherit}',
    '.hg-prod-qty__btn:hover{background:var(--hg-green-light)}',
    '.hg-prod-qty__val{width:66px;height:46px;border:none;border-left:2px solid var(--hg-green-pale);border-right:2px solid var(--hg-green-pale);text-align:center;font-size:16px;font-weight:800;color:var(--hg-navy);-moz-appearance:textfield;font-family:inherit}',
    '.hg-prod-qty__val::-webkit-outer-spin-button,.hg-prod-qty__val::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}',
    '.hg-prod-buy__total{display:flex;align-items:center;justify-content:space-between;gap:10px;background:#f8fdf2;border:1px solid var(--hg-green-pale);border-radius:10px;padding:12px 14px;margin-bottom:16px;font-size:14px;font-weight:600;color:var(--hg-text)}',
    '.hg-prod-buy__total strong{font-size:22px;font-weight:900;color:var(--hg-navy)}',
    '.hg-prod-buy__old{font-size:20px;font-weight:700;color:#999;text-decoration:line-through;margin-right:10px}',
    '.hg-buy-extra{margin-top:18px;display:flex;flex-direction:column;gap:14px}',
    '.hg-buy-accroche{display:flex;align-items:center;gap:10px;background:linear-gradient(135deg,#eafcd2,#f6ffe9);border:1px solid var(--hg-green-pale);border-left:4px solid var(--hg-green);border-radius:10px;padding:11px 14px;font-size:13px;font-weight:600;color:var(--hg-navy);line-height:1.45}',
    '.hg-buy-accroche span{font-size:18px;line-height:1;flex-shrink:0}',
    '.hg-buy-pay{border-top:1px dashed #dfe8d5;padding-top:14px;display:flex;flex-direction:column;gap:9px;align-items:center}',
    '.hg-buy-pay__label{font-size:12px;font-weight:800;color:#2e7d00;letter-spacing:.02em}',
    '.hg-buy-pay__icons{display:flex;gap:7px;flex-wrap:wrap;justify-content:center;align-items:center}',
    '.hg-buy-pay__icons img{height:26px;width:auto;display:block;border-radius:4px;box-shadow:0 1px 3px rgba(3,27,52,.14)}',
    '.hg-buy-trust{display:grid;grid-template-columns:repeat(2,1fr);gap:9px}',
    '.hg-buy-trust__item{display:flex;align-items:center;gap:9px;background:#fff;border:1px solid #e8f0e0;border-radius:10px;padding:9px 10px}',
    '.hg-buy-trust__ico{width:30px;height:30px;flex-shrink:0;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:15px;line-height:1}',
    '.hg-buy-trust__ico--a{background:#eafcd2}',
    '.hg-buy-trust__ico--b{background:#e3f0ff}',
    '.hg-buy-trust__ico--c{background:#fff3d6}',
    '.hg-buy-trust__ico--d{background:#ffe6ec}',
    '.hg-buy-trust__txt{display:flex;flex-direction:column;line-height:1.25;min-width:0}',
    '.hg-buy-trust__txt strong{font-size:12px;font-weight:800;color:var(--hg-navy)}',
    '.hg-buy-trust__txt small{font-size:10.5px;color:var(--hg-text)}',
    '@media(max-width:420px){.hg-buy-trust{grid-template-columns:1fr}}',
    '.hg-prod-price-card--promo{border-color:rgba(255,230,0,.55);background:rgba(255,230,0,.12)}',
    '.hg-prod-price-card--promo .hg-prod-price-card__label,.hg-prod-price-card--promo .hg-prod-price-card__price,.hg-prod-price-card--promo .hg-prod-price-card__sub{display:block}',
    '.hg-prod-price-card--promo .hg-prod-price-card__price{color:#ffe600;font-size:30px;font-weight:900;line-height:1.1}',
    '.hg-prod-price-card--promo .hg-prod-price-card__sub{color:rgba(255,255,255,.6);font-size:11px;margin-top:2px}'
  ].join('');

  /* Valeurs reprises de sections/hg-product.liquid, qui les fixe par handle.
     Le gabarit ne les affiche que pour les produits tagués gazon-synthetique ;
     nos bandes ne le sont pas (sinon elles héritent du configurateur de
     surface), d'où cette table. À compléter si une autre bande est créée. */
  var BARRES = {
    'saint-tropez': [5, 5, 5],
    montpellier: [4, 2, 3],
    deauville: [5, 4.5, 4],
    versailles: [4.5, 5, 5],
    bordeaux: [4, 4, 3],
    marbella: [3, 2, 2],
    beziers: [3, 1, 2],
    frejus: [4, 3, 3],
    toulon: [4, 5, 4],
    cannes: [4, 4, 5],
    ibiza: [3, 4, 4],
    samui: [2, 1, 2],
    nimes: [4, 4, 4],
    bora: [3, 3, 3],
    ales: [2, 1, 1]
  };

  function barresPour(handle) {
    var cles = Object.keys(BARRES);
    for (var i = 0; i < cles.length; i++) {
      if (handle.indexOf(cles[i]) !== -1) return BARRES[cles[i]];
    }
    return null;
  }

  /* Barres Résistance / Confort / Réalisme : le gabarit les réserve aux
     produits tagués gazon-synthetique. On les rétablit pour les gazons qui
     passent par la branche générique. */
  function ajouterBarres(handle) {
    var gauche = document.querySelector('.hg-prod-header__left');
    if (!gauche || gauche.querySelector('.hg-quality-bars')) return;
    var v = barresPour(handle);
    if (!v) return;
    var noms = ['Résistance', 'Confort', 'Réalisme'];
    var wrap = document.createElement('div');
    wrap.className = 'hg-quality-bars';
    noms.forEach(function (nom, i) {
      var row = document.createElement('div');
      row.className = 'hg-quality-bar';
      row.innerHTML =
        '<span class="hg-quality-bar__label">' + nom + '</span>' +
        '<div class="hg-quality-bar__track"><div class="hg-quality-bar__fill" style="width:' + (v[i] * 20) + '%"></div></div>' +
        '<span class="hg-quality-bar__val">' + v[i] + '/5</span>';
      wrap.appendChild(row);
    });
    gauche.appendChild(wrap);
  }

  /* Carte « Remise » sous le prix, calculée sur le compare_at réel. */
  function ajouterRemise(prix, compare) {
    var prices = document.querySelector('.hg-prod-prices');
    if (!prices || prices.querySelector('.hg-prod-price-card--promo')) return;
    if (!compare || compare <= prix) return;
    var pct = Math.floor((compare - prix) / compare * 100);
    if (pct < 1) return;
    var card = document.createElement('div');
    card.className = 'hg-prod-price-card hg-prod-price-card--promo';
    card.innerHTML =
      '<span class="hg-prod-price-card__label">Remise</span>' +
      '<span class="hg-prod-price-card__price">−' + pct + ' %</span>' +
      '<span class="hg-prod-price-card__sub">au lieu de ' + fmt(compare) + '</span>';
    prices.appendChild(card);
  }

  var PAY = [
    ['Visa', 'visa-b614b878'],
    ['Mastercard', 'master-f5a74105'],
    ['PayPal', 'paypal-a7c68b85'],
    ['Klarna', 'klarna-637a076e'],
    ['Apple Pay', 'apple_pay-1721ebad']
  ];

  var TRUST = [
    ['a', '✅', 'Qualité pro', 'Matériaux sélectionnés'],
    ['b', '🚚', 'Livraison suivie', 'Partout en France'],
    ['c', '💳', '3× ou 4×', 'sans frais avec Oney'],
    ['d', '📞', 'Conseil gratuit', 'Avant votre commande']
  ];

  function buildExtra() {
    var wrap = document.createElement('div');
    wrap.className = 'hg-buy-extra';

    var acc = document.createElement('div');
    acc.className = 'hg-buy-accroche';
    acc.innerHTML = '<span>🌿</span><div><strong>Spécialiste des sols depuis 2015.</strong> Conseil, expédition et SAV assurés par notre équipe en France.</div>';
    wrap.appendChild(acc);

    var pay = document.createElement('div');
    pay.className = 'hg-buy-pay';
    var lbl = document.createElement('span');
    lbl.className = 'hg-buy-pay__label';
    lbl.textContent = '🔒 Paiement 100 % sécurisé';
    var icons = document.createElement('div');
    icons.className = 'hg-buy-pay__icons';
    PAY.forEach(function (p) {
      var img = document.createElement('img');
      img.alt = p[0];
      img.loading = 'lazy';
      img.src = '/cdn/shopifycloud/storefront/assets/payment_icons/' + p[1] + '.svg';
      img.onerror = function () { img.style.display = 'none'; };
      icons.appendChild(img);
    });
    pay.appendChild(lbl);
    pay.appendChild(icons);
    wrap.appendChild(pay);

    var trust = document.createElement('div');
    trust.className = 'hg-buy-trust';
    TRUST.forEach(function (t) {
      var item = document.createElement('div');
      item.className = 'hg-buy-trust__item';
      item.innerHTML =
        '<div class="hg-buy-trust__ico hg-buy-trust__ico--' + t[0] + '">' + t[1] + '</div>' +
        '<div class="hg-buy-trust__txt"><strong>' + t[2] + '</strong><small>' + t[3] + '</small></div>';
      trust.appendChild(item);
    });
    wrap.appendChild(trust);

    return wrap;
  }

  function injectCss() {
    if (document.getElementById('hg-qty-css')) return;
    var s = document.createElement('style');
    s.id = 'hg-qty-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function centsFromText(txt) {
    if (!txt) return 0;
    var m = txt.replace(/ /g, ' ').match(/(\d[\d\s.]*)(?:[.,](\d{1,2}))?/);
    if (!m) return 0;
    var whole = parseInt(m[1].replace(/[\s.]/g, ''), 10) || 0;
    var dec = m[2] ? (m[2].length === 1 ? m[2] + '0' : m[2]) : '00';
    return whole * 100 + parseInt(dec, 10);
  }

  /* Format monétaire du thème : « 10,00 € », espace insécable avant le signe. */
  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function init() {
    var box = document.querySelector('.hg-prod-buy');
    if (!box) return;
    var form = box.querySelector('form[action="/cart/add"]');
    if (!form) return;
    var hidden = form.querySelector('input[name="quantity"]');
    if (!hidden || hidden.type !== 'hidden') return;

    injectCss();

    var priceEl = box.querySelector('.hg-prod-buy__price');
    var unit = centsFromText(priceEl ? priceEl.textContent : '');
    if (!unit) return;

    var qty = document.createElement('div');
    qty.className = 'hg-prod-qty';
    qty.innerHTML =
      '<span class="hg-prod-qty__label">Quantité</span>' +
      '<div class="hg-prod-qty__ctrl">' +
      '<button type="button" class="hg-prod-qty__btn" data-hg-step="-1" aria-label="Diminuer">−</button>' +
      '<input type="number" name="quantity" class="hg-prod-qty__val" value="1" min="1" step="1" inputmode="numeric" aria-label="Quantité">' +
      '<button type="button" class="hg-prod-qty__btn" data-hg-step="1" aria-label="Augmenter">+</button>' +
      '</div>';

    var totalRow = document.createElement('div');
    totalRow.className = 'hg-prod-buy__total';
    totalRow.innerHTML = '<span>Total TTC</span><strong>' + fmt(unit) + '</strong>';

    hidden.parentNode.replaceChild(qty, hidden);
    var submit = form.querySelector('button[type="submit"]');
    if (submit) form.insertBefore(totalRow, submit);
    else form.appendChild(totalRow);

    var input = qty.querySelector('.hg-prod-qty__val');
    var strong = totalRow.querySelector('strong');

    function render() {
      var q = parseInt(input.value, 10);
      if (!q || q < 1) q = 1;
      input.value = q;
      strong.textContent = fmt(unit * q);
    }

    Array.prototype.forEach.call(qty.querySelectorAll('[data-hg-step]'), function (btn) {
      btn.addEventListener('click', function () {
        var q = parseInt(input.value, 10) || 1;
        input.value = q + parseInt(btn.getAttribute('data-hg-step'), 10);
        render();
      });
    });
    input.addEventListener('input', render);
    input.addEventListener('change', render);
    render();

    if (!box.querySelector('.hg-buy-extra')) {
      box.appendChild(buildExtra());
    }

    var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          if (priceEl && !box.querySelector('.hg-prod-buy__old') &&
              p.compare_at_price && p.compare_at_price > p.price) {
            var old = document.createElement('span');
            old.className = 'hg-prod-buy__old';
            old.textContent = fmt(p.compare_at_price);
            priceEl.parentNode.insertBefore(old, priceEl);
          }
          fixPoseTab(p.type || '');
          if (p.type === 'Gazon synthétique') {
            ajouterBarres(p.handle || '');
            var lbl = document.querySelector('.hg-prod-price-card__label');
            if (lbl && lbl.textContent.trim() === 'Prix') lbl.textContent = 'Prix au m²';
          }
          ajouterRemise(p.price, p.compare_at_price);
        })
        .catch(function () {});
    }
  }

  /* L'onglet « Guide de pose » du gabarit décrit la pose d'un gazon
     (géotextile, déroulage, brossage des fibres, calepinage). Sur une dalle
     caoutchouc on remplace ces étapes ; sur un accessoire on retire l'onglet.
     Le panneau est masqué par défaut, la substitution ne provoque aucun
     clignotement à l'écran. */
  var POSE_DALLE = [
    ['Préparer le sol', 'Le sol doit être plan, propre et sec. Un balai et un coup de serpillière suffisent : aucun support à préparer.'],
    ["Partir d'un angle", "Démarrez dans l'angle le plus visible de la pièce, pour que les dalles coupées se retrouvent du côté le moins exposé."],
    ['Poser bord à bord', "Serrez bien les dalles les unes contre les autres. Elles ne s'emboîtent pas : c'est leur poids qui les maintient en place."],
    ['Découper si besoin', "Tracez au feutre sur l'envers, puis coupez au cutter à lame neuve contre une règle métallique, en trois ou quatre passes."]
  ];

  function fixPoseTab(type) {
    var panel = document.getElementById('tab-pose');
    var btn = document.querySelector('.hg-prod-tabs__btn[data-tab="pose"]');
    if (!panel) return;

    if (type !== 'Dalle caoutchouc') {
      if (btn) btn.style.display = 'none';
      panel.innerHTML = '';
      return;
    }

    var steps = document.createElement('div');
    steps.className = 'hg-pose-steps';
    POSE_DALLE.forEach(function (st, i) {
      var row = document.createElement('div');
      row.className = 'hg-pose-step';
      var num = document.createElement('span');
      num.className = 'hg-pose-step__num';
      num.textContent = String(i + 1);
      var txt = document.createElement('div');
      var h = document.createElement('h4');
      h.textContent = st[0];
      var pp = document.createElement('p');
      pp.textContent = st[1];
      txt.appendChild(h);
      txt.appendChild(pp);
      row.appendChild(num);
      row.appendChild(txt);
      steps.appendChild(row);
    });

    var link = document.createElement('a');
    link.className = 'hg-pose-guide-link';
    link.href = '/pages/contact';
    link.textContent = '📞 Un doute sur la quantité ? Écrivez-nous →';

    panel.innerHTML = '';
    panel.appendChild(steps);
    panel.appendChild(link);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
